import { FaqHero } from '@components/faq-hero'
import { useContentfulLiveUpdates } from '@contentful/live-preview/react'
import { PageMeta } from '@contentful-components/page-meta'
import { SectionResolver } from '@contentful-components/section-resolver'
import type { FaqSectionFragment } from '@graphql/fragments/FaqSectionFragment.graphql'
import { EMPTY_COLLECTION } from '@graphql/placeholders'
import type { StaticPageData } from '@lib/static/page'
import { getContenfulStaticProps } from '@lib/static/static-page'
import { titleToAnchor } from '@lib/utils/faq'
import { PAGE_OPTIONS } from '@lib/utils/page'
import type { NextPage } from 'next'

export const getStaticProps = getContenfulStaticProps(PAGE_OPTIONS.FAQ.slug)

const Page: NextPage<StaticPageData> = ({ data: initialData, slug }) => {
    // Subscribe to live updates from Contentful
    const data = useContentfulLiveUpdates(initialData)

    if (!data) return null

    const { meta, sections: { items } = EMPTY_COLLECTION } = data

    const links = items
        .filter((item) => item.type === 'SectionOfFaQs')
        .map((item) => {
            const faq = item as FaqSectionFragment
            return {
                title: faq.section?.title ?? '',
                anchor: faq.section?.title
                    ? titleToAnchor(faq.section.title)
                    : faq.sys.id,
            }
        })

    return (
        <>
            {meta && <PageMeta id={meta.sys.id} name={slug} meta={meta} />}
            <FaqHero links={links} />
            <SectionResolver sections={items} />
        </>
    )
}

export default Page
